export const AMOUNT_BASIS_PRETAX = 'pretax';
export const AMOUNT_BASIS_PRETAX_WITH_TIP = 'pretax_with_tip';
export const AMOUNT_BASIS_TAX_INCLUDED = 'tax_included';
export const AMOUNT_BASIS_RECEIPT_TOTAL = 'receipt_total';

export const TAX_BASIS_PRETAX = 'pretax';
export const TAX_BASIS_TAX_INCLUDED = 'tax_included';

export function amountBasisToUi(amountBasis) {
    const basis = amountBasis || AMOUNT_BASIS_PRETAX;

    if (basis === AMOUNT_BASIS_PRETAX_WITH_TIP) {
        return { taxBasis: TAX_BASIS_PRETAX, includeTip: true };
    }
    if (basis === AMOUNT_BASIS_TAX_INCLUDED) {
        return { taxBasis: TAX_BASIS_TAX_INCLUDED, includeTip: false };
    }
    if (basis === AMOUNT_BASIS_RECEIPT_TOTAL) {
        return { taxBasis: TAX_BASIS_TAX_INCLUDED, includeTip: true };
    }

    return { taxBasis: TAX_BASIS_PRETAX, includeTip: false };
}

export function uiToAmountBasis(taxBasis, includeTip) {
    if (taxBasis === TAX_BASIS_PRETAX) {
        return includeTip ? AMOUNT_BASIS_PRETAX_WITH_TIP : AMOUNT_BASIS_PRETAX;
    }

    return includeTip ? AMOUNT_BASIS_RECEIPT_TOTAL : AMOUNT_BASIS_TAX_INCLUDED;
}

const SUPPORTED_AMOUNT_BASES = new Set([
    AMOUNT_BASIS_PRETAX,
    AMOUNT_BASIS_PRETAX_WITH_TIP,
    AMOUNT_BASIS_TAX_INCLUDED,
    AMOUNT_BASIS_RECEIPT_TOTAL,
]);

export function resolveCategorySpendLimitAmountBasis(parameters = {}) {
    const basis = parameters.amount_basis;
    if (SUPPORTED_AMOUNT_BASES.has(basis)) {
        return basis;
    }
    return AMOUNT_BASIS_PRETAX;
}

export function normalizeCategorySpendLimitParameters(parameters = {}) {
    return {
        ...parameters,
        amount_basis: resolveCategorySpendLimitAmountBasis(parameters),
    };
}
